import * as yup from 'yup'

const REQUIRED_MESSAGE = 'This field is required'

export const AddInsuranceContactInformationModalSchema = yup.object({
  fullName: yup.string().required(REQUIRED_MESSAGE),
  email: yup.string().required(REQUIRED_MESSAGE).email('Please enter a valid email address.'),
  phoneNumber: yup
    .string()
    .required(REQUIRED_MESSAGE)
    .min(10, 'Please enter a valid cell phone number.'),
  organizationName: yup.string().required(REQUIRED_MESSAGE),
  insuranceDocuments: yup
    .array()
    .of(
      yup.object({
        file: yup.string().required(REQUIRED_MESSAGE),
        fileFileName: yup.string().required(REQUIRED_MESSAGE),
      })
    )
    .required(REQUIRED_MESSAGE),
})

export type TAddInsuranceContactInformationModalSchema = yup.InferType<
  typeof AddInsuranceContactInformationModalSchema
>
